
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6c79b534&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CustomerGroup.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomerGroup.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6c79b534!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomerGroup.vue"),
  /* scopeId */
  "data-v-6c79b534",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Customer/CustomerGroup.vue
// module id = 671
// module chunks = 0